import { DateShowtimePickerInternalAction } from '../types/internal-action';
import { getNextOrPreviousScreeningDate, ScreeningDateType } from './get-next-or-previous-screening-date';
export const getNoShowtimesForSiteDisplayTextProps = (displayText, siteId, filmId, screeningDates, selectedBusinessDate, handleDateClicked, i18n) => {
    const alternateScreeningDate = getNextOrPreviousScreeningDate(selectedBusinessDate, screeningDates, filmId, siteId);
    if (!alternateScreeningDate) {
        return { label: displayText.noShowtimesForSiteAndFilmMessage };
    }
    let label;
    if (alternateScreeningDate.type === ScreeningDateType.Next) {
        label = i18n.displayTextLabel(displayText.nextShowtimeForSiteOnDateMessage, {
            nextScreeningDate: alternateScreeningDate.screeningDate
        });
    }
    else {
        label = i18n.displayTextLabel(displayText.lastShowtimeForSiteOnDateMessage, {
            lastScreeningDate: alternateScreeningDate.screeningDate
        });
    }
    return {
        label,
        internalActions: [
            {
                name: DateShowtimePickerInternalAction.NavigateToDate,
                action: () => handleDateClicked(alternateScreeningDate.screeningDate, filmId)
            }
        ]
    };
};
